import { render } from "./user-icon.svg?vue&type=template&id=17726b24"
import script from "./user-icon.svg?vue&type=script&lang=js"
export * from "./user-icon.svg?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src844/src/s3/00/src/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__